export function splitStringByCommaOrSpace(string: string): string[] {
  return string.split(/[ ,]+/).filter((nonEmptyString) => nonEmptyString);
}
